import { render, staticRenderFns } from "./CtaItem.vue?vue&type=template&id=6ebd5527"
import script from "./CtaItem.vue?vue&type=script&lang=js"
export * from "./CtaItem.vue?vue&type=script&lang=js"
import style0 from "./CtaItem.vue?vue&type=style&index=0&id=6ebd5527&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports